import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { ColumnLayout } from "../components/Layout/ColumnLayout";
import { EquipmentSettings } from "../components/Resources/EquipmentManagement/GlobalSettings";
import { Page } from "./Page";

export const EquipmentSettingsPage = () => {
    const history = useHistory();
    const handleEquipmentLinkClick = () => {
        history.push("/resources/equipment");
    };

    return (
        <Page title="Equipment Management">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="mr-auto">
                        <Breadcrumb.Item>Resources</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleEquipmentLinkClick}>Equipment Management</Breadcrumb.Item>
                        <Breadcrumb.Item>Global Settings</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <EquipmentSettings />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
